export default "__VITE_ASSET__bi2oWh75__"